import { render, staticRenderFns } from "./ShippingLogBLDetailHeaderPop.vue?vue&type=template&id=a16471fe"
import script from "./ShippingLogBLDetailHeaderPop.vue?vue&type=script&lang=js"
export * from "./ShippingLogBLDetailHeaderPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a16471fe')) {
      api.createRecord('a16471fe', component.options)
    } else {
      api.reload('a16471fe', component.options)
    }
    module.hot.accept("./ShippingLogBLDetailHeaderPop.vue?vue&type=template&id=a16471fe", function () {
      api.rerender('a16471fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShippingLogBLDetailHeaderPop.vue"
export default component.exports